export default __webpack_public_path__ + "static/media/ETA Change2.af22a0dd.svg";